import React from 'react';
import {
	useModalDialogActions,
	useReturnFocusTo,
} from '@atlassian/jira-software-modal-dialog/src/controllers/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import MoveModal from './index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MoveModalWrapper = (props: any) => {
	const returnFocusTarget = useReturnFocusTo();
	const { setReturnFocusTo } = useModalDialogActions();

	if (fg('jfp_a11y_team_boards_directory_focus_move_modal')) {
		return (
			<MoveModal
				{...props}
				returnFocusTarget={returnFocusTarget}
				setReturnFocusTo={setReturnFocusTo}
			/>
		);
	}

	return <MoveModal {...props} />;
};

export default MoveModalWrapper;
